import moment from 'moment-timezone';

/** The scheduler packs holds into 30-minute slots, so a shortened hold can't be finer than that. */
export const SLOT_SECONDS = 30 * 60;

/** Seconds from midnight, in the account's timezone — the form's clock representation. */
export const secondsFromMidnightNow = (timezone?: string | null): number => {
  const now = moment().tz(timezone || 'utc');
  return now.hours() * 3600 + now.minutes() * 60;
};

/**
 * End time for "this customer has finished": now rounded down to the previous slot boundary, but
 * never shorter than one slot, because a hold of zero (or a negative one, if they leave before
 * their own start time) isn't representable.
 */
export const finishNowEndTimeSeconds = (startTimeSeconds: number, nowSeconds: number): number =>
  Math.max(startTimeSeconds + SLOT_SECONDS, Math.floor(nowSeconds / SLOT_SECONDS) * SLOT_SECONDS);

/**
 * Whether the hold is worth shortening — only for an order that has actually started and still has
 * more than one slot left to give back.
 */
export const canFinishNow = (startTimeSeconds: number, endTimeSeconds: number, nowSeconds: number): boolean =>
  nowSeconds >= startTimeSeconds && endTimeSeconds > startTimeSeconds + SLOT_SECONDS && nowSeconds < endTimeSeconds;
